// 
// Copyright (c) Microsoft and contributors.  All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//   http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// 
// See the License for the specific language governing permissions and
// limitations under the License.
// 

/**
* Creates a that handles server redirects;
*/
exports.create = function (maximumRetries) {
  return function handle(resource, next, callback) {
    var currentRetries = 0;
    function handleRedirect(err, response, body) {
      if (response && response.headers && response.headers.location && response.statusCode >= 300 && response.statusCode < 400 && (!maximumRetries || currentRetries < maximumRetries)) {
        currentRetries++;
        resource.url = response.headers.location;
        next(resource, handleRedirect);
      } else if (callback) {
        callback(err, response, body);
      }
    }
    return next(resource, handleRedirect);
  };
};